import type React from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import {
    renderAbbrNumberWithThresholdCellFactory,
    renderSparklineCellFactory,
} from "app/pages/sales-intelligence/common-components/table-cells";
import { MIN_RELIABLE_METRIC_VALUE } from "app/pages/sales-intelligence/constants/threshold";
import type { WebsitesDigitalAssetRecord } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";

import { BoxTextAlignRight } from "./styles";

type Props = {
    visits: WebsitesDigitalAssetRecord["visits"];
    visitsHistory: WebsitesDigitalAssetRecord["visitsHistory"];
    isHeader?: boolean;
};

export const VisitsCell: React.FC<Props> = ({ visitsHistory, visits, isHeader = false }) => {
    return (
        <Flex
            justifyContent="flex-end"
            alignItems="center"
            gap="12px"
            {...(isHeader ? { padding: "8px 0" } : {})}
        >
            <BoxTextAlignRight
                flex="0 0 25%"
                minWidth="48px"
            >
                <Text
                    fontVariant="input2"
                    color={colorsPalettes.carbon[400]}
                >
                    {renderAbbrNumberWithThresholdCellFactory({ min: MIN_RELIABLE_METRIC_VALUE })(visits)}
                </Text>
            </BoxTextAlignRight>
            <Box
                flex="0 0 70%"
                maxWidth="70%"
            >
                {renderSparklineCellFactory(visitsHistory)}
            </Box>
        </Flex>
    );
};
